import {
  AtsRejectionReasonItemFragment,
  DeleteRejectionReasonDocument,
  DeleteRejectionReasonMutation,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useDeleteRejectionReason = (rejectionReason: AtsRejectionReasonItemFragment) => {
  const [deleteRejectionReason, { loading }] = useMutation(DeleteRejectionReasonDocument, {
    extractorFn: (data: DeleteRejectionReasonMutation) =>
      data.atsMutations.deleteAtsRejectionReason,
  })

  return {
    loading,
    deleteRejectionReason() {
      return deleteRejectionReason({
        variables: { id: rejectionReason.id },
        update(cache, mutationResult) {
          if (mutationResult.data?.atsMutations.deleteAtsRejectionReason.rejectionReason) {
            cache.evict({ id: cache.identify(rejectionReason) })
          }
        },
      })
    },
  }
}
